import { helpers } from '../utils';
import * as CR from '../services/campaigns';

export const ACTION_CAMPAIGNS_LOAD_LIST = 'campaigns/loadList';

export default {
  namespace: 'campaigns',

  state: {
    campaignsList: [{
      label: '',
      key: '',
      name: '',
    }],
  },

  reducers: {
    updateStore(state, { payload }) {
      const { list = [...state.campaignsList] } = payload;
      return {
        campaignsList: list,
      };
    },
  },

  effects: {
    * loadList({ payload }, { put, call }) {
      try {
        const isPsf = Object.keys(payload).includes('filter' || 'sorting' || 'limit' || 'skip');
        const response = yield call(CR.campaignsLoadRequest, payload, isPsf);
        yield put({
          type: 'updateStore',
          payload: { list: [...response.data] },
        });
        return response;
      } catch (e) {
        helpers.processException(e);
        return e;
      }
    },

    * getCampaignById({ payload }, { put, call }) {
      try {
        const { projectId, campaignId } = payload;
        const response = yield call(CR.campaignLoadRequest, { projectId, campaignId });
        yield put({
          type: 'updateStore',
          payload: { list: [response.body] },
        });
        return response;
      } catch (e) {
        helpers.processException(e);
        return e;
      }
    },

    * createCampaign({ payload }, { call }) {
      try {
        const { projectId, campaigns } = payload;
        return yield call(CR.campaignCreateRequest, { projectId }, campaigns);
      } catch (e) {
        helpers.processException(e);
        return e;
      }
    },

    * updateCampaign({ payload }, { call }) {
      try {
        const { projectId, campaignId, campaigns } = payload;
        return yield call(CR.campaignUpdateRequest, { projectId, campaignId }, campaigns);
      } catch (e) {
        helpers.processException(e);
        return e;
      }
    },

    * removeCampaign({ payload }, { call }) {
      try {
        const { projectId, campaignId } = payload;
        return yield call(CR.campaignRemoveRequest, { projectId, campaignId });
      } catch (e) {
        return e;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/campaigns.js